import { ShadowBox } from 'components/ShadowBox'
import { Input } from 'components/atom/Input'
import { useForm, useFieldArray, Controller } from 'react-hook-form'
import React, { useEffect, useRef, useState } from 'react'
import usePostList from 'hooks/query/userPostList'
import { Modal } from 'components/layout/Modal'
import { useNavigate } from 'react-router-dom'
import 'App.css'
import useGetBgm from 'hooks/query/useGetBgm'
import useGetTransition from 'hooks/query/useGetTransition'
import useGetVoice from 'hooks/query/useGetVoice'

import { Usage } from 'service/user'
import {
  getLocalStorage,
  LOCAL_THUMBNAIL_INFO,
  removeLocalStorage,
  renderPaybackVideo,
  saveLocalStorage,
  showYoutubeAuth,
  UserType,
} from 'utils/common'

import { CSSTransition } from 'react-transition-group'
import useGetThumbnail from 'hooks/query/useGetThumbnail'

import { GuideToUse } from 'components/GuideToUse'

import { GuideModal } from 'components/freePlan/GuideModal'
import { PromotionCircle } from 'components/upgrade/PromotionCircle'

import { useGetSubtitleLong } from 'hooks/query/useGetSubtitle'
import { longFormCreateBtnClick } from 'utils/metaAd'
import { PlanPromotionBanner } from 'components/affiliate/PlanPromotionBanner'
import { usePostExperiencePlan } from 'hooks/query/usePostExperiencePlan'
import { isMobile } from 'react-device-detect'
import {
  EmptyPlan,
  FreePlan,
  LightPlan,
  ProAndPremiumPlanAnnual,
  ProAndPremiumPlanMonthly,
} from 'components/PlanDashBoard/PlanDashBoard'
import useGetMePlan from 'hooks/query/useGetMePlan'
import classNames from 'classnames'

import { FormValues } from 'utils/type'
import { PlanPriceModal } from 'components/payment/PlanPriceModal'
import useUserStore from 'store/useUserStore'
import useUsageStore from 'store/useUsageStore'
import { FreePlanBanner } from 'components/freePlan/Banner'

import { FailWithShortModal } from 'pages/product-video-editor/components/video/FailWithShortModal'

import { useMutateMyPoint } from 'hooks/query/point/useMutateMyPoint'
import { Spinner } from 'components/atom/Spinner'
import { TransitionModal } from 'pages/product-video-editor/components/video/TransitionModal'
import {
  AIRecommendProductShortTitleType,
  AiThumbnailTitle,
  LinkDetailType,
  OutroFactor,
  ThumbnailType,
  TransitionFactor,
} from 'service/list'

import useGetOutro from 'hooks/query/useGetOutro'
import useGetAIPromptGroup from 'hooks/query/useGetAIPromptGroup'

import useGetVoiceTag from 'hooks/query/useGetVoiceTag'

import useGetSticker from 'hooks/query/useGetSticker'
import useGetStickerLocation from 'hooks/query/useGetStickerLocation'

import { ReactComponent as UlClipBoardIcon } from 'svg/u_clipboard.svg'
import { ReactComponent as StarIcon } from 'svg/star_white.svg'

import { ExtensionListModal } from 'pages/product-video-editor/components/video/ExtensionListModal'

import { ExtensionTooltip } from 'pages/product-video-editor/components/video/ExtensionTooltip'
import { InstallExtensionFloating } from 'components/extension/InstallExtensionFloating'

import YouTube from 'react-youtube'
import useGetIntro from 'hooks/query/useGetIntro'
import useGetThumbnailPlacid from 'hooks/query/useGetThumbnailPlacid'
import useGetAiRecommendClipTitle from 'hooks/query/extension/useGetAiRecommendClipTitle'
import useGetAiRecommendThumbnailTitle from 'hooks/query/extension/useGetAiRecommendThumbnailTitle'
import { FeatureDescription } from 'components/FeatureDescription'
import { AuthGuard } from 'components/gaurd/AuthGuard'
import { FastclickDashBoard } from 'components/fastclick/FastclickDashBoard'
import { ExtensionErrorGuideTooltip } from 'pages/product-video-editor/components/video/ExtensionErrorGuideTooltip'
import { FastclickDescription } from 'components/fastclick/FastclickDescription'
import { ShortFormTooltip } from 'pages/product-video-editor/components/video/ShortFormTooltip'
import { Helmet } from 'react-helmet-async'
import { WithShortFormCreate } from 'pages/product-video-editor/components/video/WithShortFormCreate'
import { ExtensionListFailModal } from 'pages/product-video-editor/components/video/modal/ExtensionListFailModal'
import {
  defaultValues,
  initializeDefaults,
  initSetValue,
  loadProductShortData,
  setPromptGroupDataFromList,
  setVideoDataValueFromList,
  setVideoDataValueFromListNoUsable,
  setVideoDataValueNoUsable,
} from 'utils/videoEditorUtils'
import ProductItemEmpty from './components/product/ProductItemEmpty'
import ProductList from './components/product/ProductList'
import { ScriptInputModeToggle } from './components/ScriptInputModeToggle'
import { ScriptSelector } from './components/product/ScriptSelector'
import { useScriptStore } from 'store/useScriptStore'
import useGetUserVoice from 'hooks/query/useGetUserVoice'
import { FastcutLongformEffectSelector } from './components/effect/FastcutLongformEffectSelector'
import FastcutShortformEffectSelector from './components/effect/FastcutShortformEffectSelector'
import useGetSubtitleColor from 'hooks/query/useGetSubtitleColor'
import { logger } from 'utils/logger'
import useGetAiRecommendClipProductShortTitle from 'hooks/query/extension/useGetAiRecommendProductShortTitle'
import useGetSubtitleFont from 'hooks/query/useGetSubtitleFont'
import useGetSubtitleSize from 'hooks/query/useGetSubtitleSize'
import { MemberTitle } from './components/MemberTitle'
import { NoneMemberTitle } from './components/NoneMemberTitle'
import { TextArea } from './components/TextArea'
import { CreateVideoType } from 'constant/videoTypes'
import {
  createLongFormVideoFormData,
  createShortFormVideoData,
  PRODUCT_NAME_PATTERN,
} from './util'
import { YoutubeTitle } from './components/YoutubeTitle'
import useCreateFastCutProductShort from 'hooks/query/useCreateFastCutProductShort'

export const Video = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const LINK_PAGE_CNT = 30
  const isTime = urlParams.get('time')

  const video_page_youtube = getLocalStorage('vpy')

  const videoEditorData = getLocalStorage('videoEditorData')
  const productShortData = getLocalStorage('productShortData')

  const { mutate: myPointMutate, mutateAsync: myPointMutateAsync } =
    useMutateMyPoint()
  const { data: bgmList, refetch: bgmRefetch } = useGetBgm()
  const { data: aiPromptGroup, refetch: aiPromptGroupRefetch } =
    useGetAIPromptGroup()
  const { data: transitionList, refetch: transitonRefetch } = useGetTransition()
  const { data: outroList } = useGetOutro()
  const { data: introList } = useGetIntro()
  const { data: voiceList, refetch: voiceRefetch } = useGetVoice()
  const { data: userVoiceList, refetch: userVoiceRefetch } = useGetUserVoice()
  const { data: stickerList } = useGetSticker()
  const { data: stickerLocationList } = useGetStickerLocation()
  const { data: subtitleColorList } = useGetSubtitleColor()
  const { data: subtitleFontList } = useGetSubtitleFont()
  const { data: subtitleSizeList } = useGetSubtitleSize()
  const { data: thumbnailList, refetch: thumbnailRefetch } = useGetThumbnail()
  const { data: thumbnailPlacIdList } = useGetThumbnailPlacid()
  const { data: voiceTags } = useGetVoiceTag()
  const { data: subTitleList } = useGetSubtitleLong()
  const { mutate: experiencePlanMutate } = usePostExperiencePlan()

  const navigate = useNavigate()
  const [isFreePlanModal, SetFreePlanModal] = useState<boolean>(false)

  const userInfo = useUserStore((state: any) => state.userInfo)
  const refetch = useUserStore((state: any) => state.refetch)
  const usageRefetch = useUsageStore((state: any) => state.usageRefetch)
  const setUsageRefetch = useUsageStore((state: any) => state.setRefetch)
  const { isAIGenerated } = useScriptStore()
  const { data: userPlanInfo, refetch: planRefetch } = useGetMePlan()

  const { mutateAsync, isPending: clipTitleIsPending } =
    useGetAiRecommendClipTitle()
  const { mutateAsync: thumbnailMutateAsync, isPending: thumbnailIsPending } =
    useGetAiRecommendThumbnailTitle()

  const [aiRecommendClipTitle, setAiRecommendClipTitle] = useState<
    string[] | null
  >(null)

  const [aiRecommendThumbnailTitle, setAiRecommendThumbnailTitle] =
    useState<AiThumbnailTitle | null>(null)

  const [isAiName, setAiName] = useState(true)
  const { isPending, mutate } = usePostList()
  const {
    mutate: createFastCutProductShortMutate,
    isPending: createFastCutProductShortIsPending,
  } = useCreateFastCutProductShort()
  const [isGuideModal, setGuideModal] = useState<boolean>(false)
  const [isRequest, setRequest] = useState<boolean>(true)
  const [createVideoType, setCreateVideoType] = useState<CreateVideoType>(
    CreateVideoType.PRODUCT_LONG,
  )

  const [saveSuccessModal, setSaveSuccessModal] = useState<boolean>(false)
  const [essentialCheck, setEssentialCheck] = useState<boolean>(false)
  const [isYoutube, setIsYoutube] = useState<boolean>(false)

  const [isTransitionModal, setTransitionModal] = useState<boolean>(false)

  const [selectedLinks, setSelectedLinks] = useState<LinkDetailType[]>([])
  const [error, setError] = useState({
    products: [
      { link: false, product: false },
      { link: false, product: false },
      { link: false, product: false },
    ],
    mainTitle: false,
    thumbnail: false,
  })
  const [selectedTransitionIndex, setSelectedTransitionIndex] =
    useState<number>(0)
  const [copyTransitionList, setCopyTransitionList] = useState<
    TransitionFactor[] | []
  >([])

  const [copyOutroList, setCopyOutroList] = useState<OutroFactor[] | []>([])

  const [isOpen, setIsOpen] = useState(true)

  const [isOpenLinkMethod, setOpenLinkMethod] = useState<boolean>(false)
  const [isOpenExtensionMethod, setOpenExtensionMethod] =
    useState<boolean>(false)
  const [isOpenExtensionListFailModal, setIsOpenExtensionListFailModal] =
    useState<boolean>(false)
  const [errorText, setErrorText] = useState<React.ReactNode>('')
  const [errorTitle, setErrorTitle] = useState<string>('')

  const [shortFormTooltip, setShortFormTooltip] = useState<boolean>(false)
  const [isOpenExtensionTooltip, setOpenExtensionTooltip] =
    useState<boolean>(false)
  const [isOpenExtensionErrorGuideTooltip, setOpenExtensionErrorGuideTooltip] =
    useState<boolean>(false)
  const [usage, setUsage] = useState<Usage>()

  const [mobileStatus, setMobileStatus] = useState<boolean>(false)
  const [isPlanPriceModal, setPlanPriceModal] = useState<boolean>(false)
  const [isFailWithShortModal, setFailWithShortModal] = useState<boolean>(false)
  const [placIdThumbnail, setPlacIdThumbnail] = useState<
    { id: number; path: string }[]
  >([])

  const [selectedPlacIdThumbnail, setSelectedPlacIdThumbnail] = useState<{
    id: number
    path: string
  } | null>(null)
  const [selectedItem, setSelectedItem] = useState<ThumbnailType | null>(null)
  const [isSaveThumbnail, setIsSaveThumbnail] = useState<boolean>(false)

  // inputRef
  const mainTitleInputRef = useRef<null | HTMLInputElement>(null)
  const thumbNailDivRef = useRef<null | HTMLDivElement>(null)
  const subtitleDivRef = useRef<null | HTMLDivElement>(null)
  const transitionDivRef = useRef<null | HTMLDivElement>(null)
  const productsRef = useRef<null | HTMLDivElement>(null)

  // 중복 호출 방지를 위한 ref
  const isSubmittingRef = useRef<boolean>(false)
  const [selectedLinkIds, setSelectedLinkIds] = useState<number[]>([])
  const [linkPageSize, setLinkPageSize] = useState(LINK_PAGE_CNT)
  const [linkCurrentPage, setLinkCurrentPage] = useState(1)
  const [isOpenYoutube, setOpenYoutube] = useState(true)
  const [isYoutubeCheckBox, setYoutubeCheckbox] = useState(false)

  const [isExtensionInstalled, setIsExtensionInstalled] =
    useState<boolean>(false)

  const {
    control,
    handleSubmit,
    watch,
    setValue,
    trigger,
    formState: { errors },
  } = useForm<FormValues>({
    defaultValues: defaultValues,
    mode: 'onSubmit',
    shouldUnregister: false,
  })
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'products',
    rules: {
      maxLength: 5,
    },
  })

  const translatePlanName = (planName: string) => {
    let tPlanName = ''
    switch (planName) {
      case '라이트':
        tPlanName = 'LIGHT'
        break
      case '프로':
        tPlanName = 'PRO'
        break
      case '프리미엄':
        tPlanName = 'PREMIUM'
        break
    }
    return tPlanName
  }

  const paymentFreePlan = () => {
    if (!userPlanInfo && userInfo?.experiencedUser) {
      return setPlanPriceModal(true)
    }
    if (!userInfo?.userInfo) {
      navigate('/sign-up')
      return
    } else if (userInfo && userInfo?.userType === UserType.체험) {
      return
    }

    experiencePlanMutate('', {
      onSuccess: (data) => {
        refetch()
        planRefetch()
      },
      onError: (e) => {
        console.log(e)
      },
    })
  }

  const scrollToRef = useRef<HTMLDivElement>(null)
  const handleScroll = () => {
    if (scrollToRef.current) {
      // scrollIntoView를 사용해 해당 위치로 스크롤
      scrollToRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      })
    }
  }

  const handleScrollToDivRef = (divRef: React.RefObject<HTMLDivElement>) => {
    if (divRef.current) {
      // scrollIntoView를 사용해 해당 위치로 스크롤
      divRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      })
    }
  }

  const onSubmit = async (data: FormValues) => {
    console.log('🔥 onSubmit 호출됨! ref 상태:', isSubmittingRef.current)

    // 중복 호출 방지
    if (isSubmittingRef.current) {
      console.log('⛔ 이미 제출 중입니다. 중복 호출을 방지합니다.')
      return
    }

    console.log('✅ ref 체크 통과, 제출 시작')
    isSubmittingRef.current = true

    console.log(data)
    if (!userInfo) {
      isSubmittingRef.current = false
      return navigate('/sign-up')
    }
    if (createVideoType === CreateVideoType.PRODUCT_LONG) {
      try {
        const formData = await createLongFormVideoFormData(
          data,
          userInfo,
          setRequest,
          isAIGenerated,
          setErrorText,
          scrollToProducts,
          setEssentialCheck,
          isOpenLinkMethod,
          selectedLinkIds,
          myPointMutateAsync,
          setFailWithShortModal,
          thumbNailDivRef,
          transitionDivRef,
          isRequest,
          watch,
        )
        if (formData) {
          mutate(formData, {
            onSuccess: () => {
              longFormCreateBtnClick()
              setRequest(true)
              isSubmittingRef.current = false
              setSaveSuccessModal((prev) => !prev)
              removeLocalStorage(LOCAL_THUMBNAIL_INFO)
              scrollToProducts()
            },
            onError: (e: any) => {
              //@ts-ignore
              const serverErrorMsg = e.response?.data?.message || e.message
              const errorType = e.response?.data?.error
              const status = e?.response?.status
              if (status === 413) {
                setErrorTitle('🚨 첨부파일 용량을 확인해주세요!')
                setErrorText('첨부된 파일이 총 20MB를 넘지 않게 조절해주세요')
              } else if (errorType === 'maxSize') {
                setErrorTitle('🚨 첨부파일 용량을 확인해주세요!')
                setErrorText('첨부된 파일이 개당 5MB를 넘지 않게 조절해주세요.')
              } else {
                setErrorTitle('🙌 필수 정보를 확인해주세요!')
                setErrorText(serverErrorMsg)
              }
              setRequest(true)
              isSubmittingRef.current = false
              setEssentialCheck(true)
            },
          })
        }
      } catch (error: any) {
        setRequest(true)
        isSubmittingRef.current = false
        console.log(error, 'error')
        if (error?.message === 'extensionCollectId is Undefined') {
          setErrorTitle('⚠️ 영상 생성 중 오류가 발생했어요.')
          setErrorText(
            <>
              <p>화면 오른쪽 아래 [민트색 상담톡 버튼] 클릭 {`>`} </p>
              <p> [🚨영상 오류 문의] 클릭 {'>'} "생성중 오류" </p>
              <p>
                {' '}
                라고 입력해주세요! 확인 후{' '}
                <span className="font-bold text-main">3,000캐시</span>{' '}
                드릴게요!`{' '}
              </p>
            </>,
          )
          scrollToProducts()
          setEssentialCheck(true)
        }
      } finally {
        console.log('🔄 롱폼 finally isSubmittingRef:', isSubmittingRef.current)
      }
    } else if (createVideoType === CreateVideoType.PRODUCT_SHORT) {
      const fastcutProductShortData = await createShortFormVideoData(
        data,
        subTitleList,
        bgmList,
      )
      const selectedDetails = fastcutProductShortData.product.selectedDetails
      const selectedThumbnails =
        fastcutProductShortData.product.selectedThumbnails
      const selectedVideos = fastcutProductShortData.product.selectedVideos
      if (
        selectedDetails.length +
          selectedThumbnails.length +
          selectedVideos.length <=
        0
      ) {
        setErrorTitle('🚨 비디오, 썸네일, 상세페이지')
        setErrorText('비디오, 썸네일, 상세페이지 중 한개는 선택해야합니다!')
        setRequest(true)
        setEssentialCheck(true)
        return
      }
      try {
        if (fastcutProductShortData) {
          createFastCutProductShortMutate(fastcutProductShortData, {
            onSuccess: () => {
              setRequest(true)
              isSubmittingRef.current = false
              setSaveSuccessModal((prev) => !prev)
              removeLocalStorage(LOCAL_THUMBNAIL_INFO)
              scrollToProducts()
            },
            onError: (e: any) => {
              //@ts-ignore
              const serverErrorMsg = e.response?.data?.message || e.message
              const errorType = e.response?.data?.error
              const status = e?.response?.status
              isSubmittingRef.current = false
              if (status === 413) {
                setErrorTitle('🚨 첨부파일 용량을 확인해주세요!')
                setErrorText('첨부된 파일이 총 20MB를 넘지 않게 조절해주세요')
              } else if (errorType === 'maxSize') {
                setErrorTitle('🚨 첨부파일 용량을 확인해주세요!')
                setErrorText('첨부된 파일이 개당 5MB를 넘지 않게 조절해주세요.')
              } else {
                setErrorTitle('🙌 필수 정보를 확인해주세요!')
                setErrorText(serverErrorMsg)
              }
              setRequest(true)
              setEssentialCheck(true)
            },
          })
        }
      } catch (error: any) {
        setRequest(true)
        isSubmittingRef.current = false
        console.log('🔄 숏폼 catch - ref 초기화됨')
        if (error?.message === 'extensionCollectId is Undefined') {
          setErrorTitle('⚠️ 영상 생성 중 오류가 발생했어요.')
          setErrorText(
            <>
              <p>화면 오른쪽 아래 [민트색 상담톡 버튼] 클릭 {`>`} </p>
              <p> [🚨영상 오류 문의] 클릭 {'>'} "생성중 오류" </p>
              <p>
                {' '}
                라고 입력해주세요! 확인 후{' '}
                <span className="font-bold text-main">3,000캐시</span>{' '}
                드릴게요!`{' '}
              </p>
            </>,
          )
          scrollToProducts()
          setEssentialCheck(true)
        }
      } finally {
        console.log('🔄 숏폼 finally ')
      }
    }
  }

  const toggleContent = () => {
    handleScrollToDivRef(thumbNailDivRef)
    setIsOpen(!isOpen)
  }

  const [videoPlaying, setVideoPlaying] = useState<boolean[]>(
    new Array(transitionList?.length).fill(false),
  )

  const [voicePlaying, setVoicePlaying] = useState<boolean[]>(
    new Array(voiceList?.length).fill(false),
  )

  const [bgmPlaying, setBgmPlaying] = useState<boolean[]>(
    new Array(bgmList?.length).fill(false),
  )

  const [toneTooltip, setToneTooltip] = useState<boolean[]>([])
  const [promptStatus, setPromptStatus] = useState<boolean[]>([])

  //여러개 tooltip 관리

  const handleMouseLeave = (index: number) => {
    if (videoRefs.current[index]) {
      try {
        videoRefs.current[index]!.currentTime = 1
        videoRefs.current[index]!.pause()
      } catch (e) {
        console.log(e, 'not pause video index:', index)
      }
    }
  }

  // bgm / transition / voice handle function 부분
  const videoRefs = useRef<(HTMLVideoElement | null)[]>([])
  const videoRef = useRef<HTMLVideoElement | null>(null)
  const bgmRefs = useRef<(HTMLAudioElement | null)[]>([])

  const handleBgmPlayButtonClick = (status: boolean, index: number) => {
    const updatedPlayingState = bgmPlaying.map((value, idx) =>
      idx === index ? status : false,
    )
    setBgmPlaying(updatedPlayingState)

    if (bgmRefs.current[index]) {
      if (status) {
        bgmRefs.current[index]?.play()
      } else {
        bgmRefs.current[index]?.pause()
      }
    }
  }

  const handleSelectedTransition = (behavior: boolean) => {
    if (videoRef.current && behavior) {
      if (videoRef.current!.readyState >= 2) {
        try {
          videoRef.current!.muted = true
          videoRef.current!.currentTime = 0
          videoRef.current?.play().catch((error) => {
            console.warn('Playback failed:', error)
          })
        } catch (e) {
          console.log(e, 'not play video index:')
        }
      }
    } else if (videoRef.current && !behavior) {
      if (videoRef.current!.readyState >= 2) {
        try {
          videoRef.current!.currentTime = 1
          videoRef.current?.pause()
        } catch (e) {
          console.log(e, 'not play video index:')
        }
      }
    }
  }

  const handleVideoEnded = (index: number) => {
    const updatedPlayingState = [...videoPlaying]
    updatedPlayingState[index] = false
    setVideoPlaying(updatedPlayingState)
  }

  const handlePlayButtonClick = (index: number) => {
    const updatedPlayingState = videoPlaying.map((value, idx) =>
      idx === index ? true : false,
    )
    setVideoPlaying(updatedPlayingState)
  }

  const isFreePlanOrUser = () => {
    if (!userInfo) {
      return (
        <FreePlanBanner
          SetFreePlanModal={SetFreePlanModal}
          paymentFreePlan={paymentFreePlan}
        />
      )
    } else if (
      userInfo &&
      userInfo?.userType === UserType.USER &&
      !userInfo?.experiencedUser
    ) {
      return (
        <FreePlanBanner
          SetFreePlanModal={SetFreePlanModal}
          paymentFreePlan={paymentFreePlan}
        />
      )
    }
    return null
  }

  const handleLoadedMetadata = (index: number) => {
    if (videoRefs.current[index]) {
      videoRefs.current[index]!.currentTime = 1
      videoRefs.current[index]!.pause()
    }
  }
  const handleInitData = () => {
    initSetValue(setValue, watch)
    setPlacIdThumbnail([])
    setIsSaveThumbnail(false)
    setAiRecommendClipTitle(null)
    setAiRecommendThumbnailTitle(null)
    setPlacIdThumbnail([])
    setOpenExtensionMethod(false)
    setOpenLinkMethod(false)
    setSelectedLinkIds([])
    setSelectedLinks([])
    setAiRecommendClipTitle(null)
    setSelectedPlacIdThumbnail(null)
    setSelectedItem(null)
  }

  const setVideoData = () => {
    if (!videoEditorData) {
      //* 기존 저장 정보가 없을때 각 list의 default로 셋팅이 되어야함 // initializeDefaults 대체
      initializeDefaults({
        setValue,
        aiPromptGroup,
        voiceList,
        transitionList,
        introList,
        outroList,
        bgmList,
        subTitleList,
        stickerList,
        stickerLocationList,
        subtitleColorList,
        subtitleFontList,
        subtitleSizeList,
        setPromptStatus,
        setToneTooltip,
        setCopyOutroList,
        setCopyTransitionList,
      })
      return
    }

    const {
      voiceId,
      userVoiceId,
      bgmId,
      transitionId,
      aiPromptTypeId,
      aiToneTypeId,
      subtitleId,
      introId,
      includePrice,
      outroId,
      stickerLocation,
      stickerId,
      includeAdd,
      subtitleColorId,
      subtitleFontId,
      subtitleSizeId,
    } = videoEditorData

    setPromptGroupDataFromList(
      aiPromptGroup,
      setValue,
      setToneTooltip,
      aiPromptTypeId,
      aiToneTypeId,
    )

    setVideoDataValueFromList(voiceList, setValue, 'voiceId', Number(voiceId))

    setVideoDataValueFromList(
      transitionList,
      setValue,
      'transitionId',
      Number(transitionId),
    )

    setVideoDataValueFromList(
      subTitleList,
      setValue,
      'subtitleId',
      Number(subtitleId),
    )
    setVideoDataValueFromList(introList, setValue, 'introId', Number(introId))
    setVideoDataValueFromList(
      stickerList,
      setValue,
      'stickerId',
      Number(stickerId),
    )
    setVideoDataValueFromList(outroList, setValue, 'outroId', Number(outroId))

    setVideoDataValueFromListNoUsable(
      userVoiceList,
      setValue,
      'userVoiceId',
      Number(userVoiceId),
    )

    setVideoDataValueNoUsable(
      subtitleFontList,
      setValue,
      'subtitleFontId',
      subtitleFontId,
    )

    setVideoDataValueNoUsable(
      subtitleSizeList,
      setValue,
      'subtitleSizeId',
      subtitleSizeId,
    )

    //! -- 여기서부터는 list가 plan에 묵여있지 않아서 usable이 없이 그냥 선택 가능한 속성
    setValue('bgmId', bgmId)
    setValue('includePrice', includePrice)
    setValue('includeAdd', includeAdd)
    setValue('stickerLocation', stickerLocation)
    setValue('subtitleColorId', subtitleColorId)
  }
  useEffect(() => {
    const userType = userInfo?.userType
    if (voiceList) setVoicePlaying(new Array(voiceList.length).fill(false))
    if (bgmList) setBgmPlaying(new Array(bgmList.length).fill(false))
    if (aiPromptGroup)
      setPromptStatus(new Array(aiPromptGroup.length).fill(false))
    if (transitionList) {
      setVideoPlaying(new Array(transitionList.length).fill(false))
      setCopyTransitionList(transitionList)
    }
    if (outroList) setCopyOutroList(outroList)
    if (userInfo) {
      userType === UserType['숏폼 스페셜']
        ? setCreateVideoType(CreateVideoType.PRODUCT_SHORT)
        : setCreateVideoType(CreateVideoType.PRODUCT_LONG)

      if (
        userInfo?.userType === UserType.체험 &&
        Number(userInfo?.usage?.usedCount) === 0
      ) {
        setGuideModal(isTime ? false : true)
      }
      setUsage(userInfo.usage)
    }
    if (userType === UserType['숏폼 스페셜']) {
      loadProductShortData(
        productShortData,
        setValue,
        aiPromptGroup,
        voiceList,
        userVoiceList,
        bgmList,
        subTitleList,
        subtitleColorList,
        subtitleFontList,
        subtitleSizeList,
        setPromptStatus,
        setToneTooltip,
      )
    } else {
      setVideoData()
    }
  }, [
    userInfo,
    outroList,
    subTitleList,
    subtitleColorList,
    aiPromptGroup,
    transitionList,
    bgmList,
    voiceList,
    stickerList,
    stickerLocationList,
    userVoiceList,
  ])

  useEffect(() => {
    if (isTime === '1') {
      bgmRefetch()
      transitonRefetch()
      voiceRefetch()
      aiPromptGroupRefetch()
      thumbnailRefetch()
    }
  }, [isTime])

  useEffect(() => {
    bgmRefs.current.forEach((audioRef, index) => {
      if (audioRef && !bgmPlaying[index]) {
        audioRef.pause()
        audioRef.currentTime = 0
      }
    })
  }, [bgmPlaying])

  useEffect(() => {
    if (refetch) {
      refetch()
    }
  }, [])

  // usageRefetch 설정
  useEffect(() => {
    if (planRefetch && typeof planRefetch === 'function') {
      setUsageRefetch(planRefetch)
    }
  }, [planRefetch, setUsageRefetch])

  const chartElByTab = () => {
    return (
      <>
        {userInfo?.userType === UserType.라이트 && (
          <>
            <LightPlan
              subscriptionType={
                userPlanInfo?.planPrice?.planPrice[0].subscriptionType ?? ''
              }
              startDate={userPlanInfo?.subscriptions?.startDate ?? '--'}
              endDate={userPlanInfo?.subscriptions?.endDate ?? '--'}
              currentMonth={userPlanInfo?.subscriptions?.currentMonth ?? ''}
              subscriptions={userPlanInfo?.subscriptions}
              monthStart={userPlanInfo?.subscriptions.monthStart ?? '--'}
              monthEnd={userPlanInfo?.subscriptions.monthEnd ?? '--'}
            />
          </>
        )}
        {(userInfo?.userType === UserType.프로 ||
          userInfo?.userType === UserType.프리미엄 ||
          userInfo?.userType === UserType['숏폼 스페셜']) &&
        userInfo?.subscriptions?.subscriptionType === 'annual' ? (
          <>
            <ProAndPremiumPlanAnnual
              userType={userInfo?.userType}
              subscriptionType={
                userPlanInfo?.planPrice?.planPrice[0].subscriptionType ?? ''
              }
              startDate={userPlanInfo?.subscriptions?.monthStart ?? '--'}
              endDate={userPlanInfo?.subscriptions?.monthEnd ?? '--'}
              currentMonth={userPlanInfo?.subscriptions?.currentMonth ?? ''}
              available={userPlanInfo?.usage?.available ?? false}
              couponBenefit={userInfo?.couponBenefit}
              isDone={userPlanInfo?.usage?.isDone}
              subscriptions={userPlanInfo?.subscriptions}
            />
          </>
        ) : (
          (userInfo?.userType === UserType.프로 ||
            userInfo?.userType === UserType.프리미엄 ||
            userInfo?.userType === UserType['숏폼 스페셜']) &&
          userInfo?.subscriptions?.subscriptionType === 'monthly' && (
            <>
              {' '}
              <ProAndPremiumPlanMonthly
                userType={userInfo?.userType}
                subscriptionType={
                  userPlanInfo?.planPrice?.planPrice[0].subscriptionType ?? ''
                }
                startDate={userPlanInfo?.subscriptions?.startDate ?? '--'}
                endDate={userPlanInfo?.subscriptions?.endDate ?? '--'}
                currentMonth={userPlanInfo?.subscriptions?.currentMonth ?? ''}
                available={userPlanInfo?.usage?.available ?? false}
                isDone={userPlanInfo?.usage?.isDone}
                couponBenefit={userInfo?.couponBenefit}
                subscriptions={userPlanInfo?.subscriptions}
              />
            </>
          )
        )}
        {userInfo?.userType === UserType.USER && (
          <>
            <EmptyPlan
              subscriptionType={
                userPlanInfo?.planPrice?.planPrice[0].subscriptionType ?? ''
              }
              startDate={userPlanInfo?.subscriptions?.startDate ?? '--'}
              endDate={userPlanInfo?.subscriptions?.endDate ?? '--'}
              currentMonth={userPlanInfo?.subscriptions?.currentMonth ?? ''}
              setPlanPriceModal={setPlanPriceModal}
            />
          </>
        )}
        {userInfo?.userType === UserType.체험 && (
          <>
            <FreePlan
              userType={userInfo?.userType}
              subscriptionType={
                userPlanInfo?.planPrice?.planPrice[0].subscriptionType ?? ''
              }
              startDate={userPlanInfo?.subscriptions?.startDate ?? '--'}
              endDate={userPlanInfo?.subscriptions?.endDate ?? '--'}
              currentMonth={userPlanInfo?.subscriptions?.currentMonth ?? ''}
              totalLimit={userPlanInfo?.usage?.totalLimit ?? 0}
              usedCount={userPlanInfo?.usage?.usedCount ?? 0}
              available={userPlanInfo?.usage?.available ?? false}
              couponBenefit={userInfo?.couponBenefit}
              isDone={userPlanInfo?.usage?.isDone}
              subscriptions={userPlanInfo?.subscriptions}
            />
          </>
        )}
      </>
    )
  }

  const handlePriceModal = () => {
    /**
     * userInfo는 있고
     * 유저타입이 일반은 사람에게만 띄우기
     * 1.예전에 체험을 해본사람
     * 2. 무료체험 완료한사람
     * 3. 무료체험 신청전 일반유저
     */
    if (!userInfo) {
      navigate('/sign-up')
      return
    }
    if (!userPlanInfo && userInfo?.userType === UserType.체험) {
      return setPlanPriceModal((prev) => !prev)
    }
    if (userInfo?.userType === UserType.체험) {
      const totalLimit = Number(userInfo?.usage?.totalLimit)
      const usedCount = Number(userInfo?.usage?.usedCount)
      if (totalLimit === usedCount) {
        return setPlanPriceModal((prev) => !prev)
      }
    }
    if (userInfo?.userType === UserType.USER) {
      return setPlanPriceModal((prev) => !prev)
    }
  }

  const scrollToProducts = () => {
    console.log('scroll', productsRef)
    if (productsRef.current) {
      productsRef.current.focus()
      productsRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      })
    }
  }

  const selectErrorText = (
    mainTitle?: any,
    products?: any,
    thumbnailInfo?: any,
    subtitleId?: any,
  ) => {
    const checkProducts = watch('products')
    const res = checkProducts.filter((el) => !el.link.trim())
    if (res.length === 3) {
      setErrorText(
        '최소 1개의 상품 링크 입력을 하셔야 영상 생성 요청이 가능합니다.',
      )
      scrollToProducts()
      return
    }

    if (products) {
      // 에러가 1~3개 까지 발생가능
      // 각각 링크와 상품명에 대해서 발생 가능
      // text => 상품 1의 상품명을 입력해주세요
      for (const product of products) {
        if (product) {
          const { link, productName, productTitle } = product

          const linkIndex = link?.ref?.name.replace(
            /products|\blink\b|\.|/g,
            '',
          )
          const nameIndex = productName?.ref?.name.replace(
            /products|\bproductName\b|\.|/g,
            '',
          )
          if (link?.type === 'validate' || link?.type === 'required') {
            setErrorText(`상품 ${Number(linkIndex) + 1}의 링크를 확인해주세요.`)
            scrollToProducts()
            return
          } else if (productName?.message === 'required') {
            setErrorText(
              `상품 ${Number(nameIndex) + 1}의 상품명을 입력해주세요`,
            )

            scrollToProducts()
            return
          } else if (productName?.type === 'maxLength') {
            setErrorText(
              `상품 ${Number(nameIndex) + 1}의 상품명 글자 수가 초과되었어요`,
            )

            scrollToProducts()
            return
          } else if (productTitle?.type === 'required') {
            setErrorText(`영상 제목은 필수입니다!`)

            if (thumbNailDivRef.current) {
              thumbNailDivRef.current.focus()
              thumbNailDivRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
              })
            }
            return
          }
        }
      }
    }
    if (mainTitle) {
      const { type } = mainTitle
      if (type === 'required') {
        setErrorText('유튜브 영상용 제목을 입력해주세요.')
      } else {
        setErrorText('유튜브 영상용 제목 글자 수가 초과되었어요')
      }
      if (mainTitleInputRef.current) {
        mainTitleInputRef.current.focus()
        mainTitleInputRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        })
      }
      return
    }
    if (thumbnailInfo) {
      setErrorText('썸네일 스타일과 썸네일 내용을 입력해주세요')
      if (thumbNailDivRef.current) {
        thumbNailDivRef.current.focus()
        thumbNailDivRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        })
      }
      return
    }

    if (subtitleId) {
      setErrorText('나레이션 자막 삽입 여부를 선택해주세요')
      if (subtitleDivRef.current) {
        subtitleDivRef.current.focus()
        subtitleDivRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        })
      }
      return
    }
    setErrorText('errors')
  }

  const findError = (mainTitle: any, products: any, thumbnail: any) => {
    const updateError = { ...error }
    //1. mainTtitle
    if (mainTitle) {
      updateError.mainTitle = true
    } else {
      updateError.mainTitle = false
    }
    if (thumbnail) {
      updateError.thumbnail = true
    } else {
      updateError.thumbnail = false
    }
    if (products) {
      for (const product of products) {
        if (product) {
          const { link, productName, productTitle } = product

          if (link) {
            const linkIndex = link?.ref?.name.replace(
              /products|\blink\b|\.|/g,
              '',
            )
            updateError.products[linkIndex].link = true
          }
          if (productName) {
            const nameIndex = productName?.ref?.name.replace(
              /products|\bproductName\b|\.|/g,
              '',
            )
            updateError.products[nameIndex].product = true
          }
          if (productTitle) {
            const nameIndex = productTitle?.ref?.name.replace(
              /products|\bproductTitle\b|\.|/g,
              '',
            )
            updateError.products[nameIndex].product = true
          }
        }
      }
    } else {
      updateError.products = [
        { link: false, product: false },
        { link: false, product: false },
        { link: false, product: false },
      ]
    }

    setError(updateError)
  }

  return (
    <>
      <Helmet>
        <title>상품 영상 만들기</title>
        <meta
          name="description"
          content="쿠팡, 알리 상품페이지 링크로 원클릭! 상품 리뷰 영상 생성하기"
        />
        <link
          rel="canonical"
          href="https://fastcut.fastseller.shop/video-editor"
        />
      </Helmet>
      <div className="relative mx-auto my-0 flex w-[375px] flex-col items-center gap-[16px] md:w-[816px]">
        {/* 회원 / 비회원 타이틀 다르게 */}
        {userInfo ? (
          <MemberTitle
            userInfo={userInfo}
            createVideoType={createVideoType}
            isExtensionInstalled={isExtensionInstalled}
          />
        ) : (
          <NoneMemberTitle
            userInfo={userInfo}
            isExtensionInstalled={isExtensionInstalled}
          />
        )}
        {/* 페이백 배너 렌더링 */}

        {createVideoType !== CreateVideoType.PRODUCT_SHORT &&
          renderPaybackVideo(userInfo)}
        {/* 무료체험 배너 */}
        {!isMobile && isFreePlanOrUser()}
        {/* 현황 데시보드 */}

        <AuthGuard userInfo={userInfo}>
          <div className="flex w-[343px] flex-col rounded-b-[20px] rounded-t-[20px] bg-[#F6F8FB] p-[10px] md:w-full md:rounded-tr-[20px] md:px-10 md:py-8">
            <div className="name mb-2">
              {userInfo?.userInfo?.name}
              {` `}({userInfo?.userInfo?.email}){` `}님
            </div>
            <div className="relative flex flex-col items-center gap-4 md:flex-row md:justify-between">
              {chartElByTab()}
            </div>
            <FastclickDashBoard userInfo={userInfo} blockWidth="w-full" />
          </div>
        </AuthGuard>

        {/* 유튜브 / 업그레이드 / 사용소진 / 미션쿠폰 등 */}
        <div className="flex w-[343px] flex-col items-center gap-5 md:w-[776px]">
          {userInfo?.couponBenefit && (
            <div className="flex w-[343px] justify-center md:w-full">
              <button
                className="h-[42px] w-full rounded-[40px] bg-main text-white"
                style={{
                  background: 'linear-gradient(to right, #6095FF, #D512E7)',
                }}
              >
                <span className="font-[Tenada] font-[800]">
                  {userInfo.couponBenefit.couponDescription}
                </span>
              </button>
            </div>
          )}{' '}
          <div className="flex w-full flex-col items-center gap-5 md:flex-row md:justify-center md:gap-[14px]">
            {userInfo?.affiliate?.plan?.length > 0 && (
              <PlanPromotionBanner
                daysLeft={userInfo?.affiliate.plan[0].daysLeft}
                hoursLeft={userInfo?.affiliate.plan[0].hoursLeft}
                affiliateImage={userInfo?.affiliate.plan[0].affiliateImage}
                affiliateDescription={
                  userInfo?.affiliate.plan[0].affiliateDescription
                }
                description={userInfo?.affiliate.plan[0].description}
              />
            )}
            {showYoutubeAuth(
              userInfo,
              'flex justify-center items-center w-[343px] h-[46px] bg-error text-white font-bold text-[14px] rounded-[40px]',
            )}
            <PromotionCircle
              userInfo={userInfo}
              planId={userInfo?.subscriptionType?.planId}
              classNameProps="w-full h-[34px]  rounded-full text-white font-bold"
            />
          </div>
          {/* 횟수 제한 표시 dic */}
          {userInfo &&
            usage &&
            !usage?.available &&
            userInfo?.userType !== UserType.체험 && (
              <div className="flex h-[58px] w-[343px] flex-col items-center justify-center rounded-[40px] bg-[#F6F8FB] md:h-[46px] md:w-[816px] md:flex-row md:gap-[18px]">
                <p className="text-[14px] font-bold md:text-[18px]">
                  기한 내 사용 가능 횟수를 모두 소진하셨어요!
                </p>
                <p className="text-[14px] font-bold md:text-[18px]">
                  <span className="text-main">요청 {usage.usedCount}개</span> /{' '}
                  {usage?.totalLimit}개
                </p>
              </div>
            )}
        </div>

        {isOpenYoutube && !video_page_youtube && (
          <div className="flex flex-col">
            <div className="flex items-center justify-end">
              <input
                type="checkbox"
                className="mr-1 h-[18px] w-[18px]"
                onClick={() => {
                  setYoutubeCheckbox((prev) => !prev)
                }}
                checked={isYoutubeCheckBox}
              />
              <p>확장 프로그램 안내 영상 다시 보지 않기</p>
              <img
                src="assets/img/icon_x.png"
                alt=""
                className="h-[24px] w-[24px] cursor-pointer"
                onClick={() => {
                  saveLocalStorage('vpy', isYoutubeCheckBox)
                  setOpenYoutube((prev) => !prev)
                }}
              />
            </div>
            <YouTube
              videoId={'VMJKnYM8rH4'}
              opts={{
                width: isMobile ? '343' : '816',
                height: isMobile ? '193' : '495',
                playerVars: {
                  autoplay: 1, // 자동 재생
                },
              }}
            />
          </div>
        )}

        <form
          onClick={handlePriceModal}
          onSubmit={handleSubmit(onSubmit, (err) => {
            const { mainTitle, products, thumbnailInfo, subtitleId } = err
            console.log('전체 에러:', err)
            console.log('products 에러:', products)
            findError(mainTitle, products, thumbnailInfo)
            selectErrorText(mainTitle, products, thumbnailInfo, subtitleId)
            setEssentialCheck(true)
          })}
          className={`flex flex-col gap-[20px] ${
            usage &&
            userInfo?.userType !== UserType.체험 &&
            !usage?.available &&
            'opacity-[0.2]'
          }`}
        >
          {/* 스크립트 생성 방법  */}
          <ScriptInputModeToggle watch={watch} setValue={setValue} />

          <ShadowBox className="w-[375px] md:w-[816px]">
            <div
              className={classNames(
                'flex w-[375px] flex-col items-center gap-[4px] md:w-[736px] md:gap-[16px]',
                { 'px-4': isMobile },
              )}
            >
              <div className="mt-[40px] flex w-[343px] flex-col items-center md:mt-0 md:w-full">
                <h3 className="text-[24px] font-bold text-[#2E343D]">
                  영상으로 만들 상품 선택
                </h3>
                <p className="text-[14px] text-[#8F929B]">
                  패스트컷 확장프로그램에서 수집한 쿠팡, 알리익스프레스 상품을
                  선택해서 영상을 만들어보세요!
                </p>
              </div>

              <div
                className="mt-1 flex w-[375px] flex-col gap-[16px] md:w-[736px]"
                ref={productsRef}
              >
                <div className=" ">
                  <div
                    className={classNames('', {
                      'flex flex-col gap-2': !isMobile,
                      'flex flex-col items-center justify-center': isMobile,
                    })}
                  >
                    <button
                      className={classNames(
                        'flex h-[48px] items-center justify-center gap-2 rounded-full bg-main text-[14px] font-bold text-white',
                        {
                          'w-full': !isMobile,
                          'w-[343px]': isMobile,
                        },
                      )}
                      type="button"
                      onClick={() => {
                        if (isOpenLinkMethod && !isOpenExtensionMethod) {
                          setOpenLinkMethod(false)
                        }
                        setOpenExtensionMethod((prev) => !prev)
                      }}
                    >
                      <UlClipBoardIcon />
                      확장 프로그램에서 수집한 상품 선택하기
                    </button>
                    {isMobile ? (
                      <>
                        {' '}
                        <p
                          className={classNames(
                            'relative mt-2 flex items-center gap-1 text-[14px]',
                            { 'w-full px-4': isMobile },
                          )}
                        >
                          {' '}
                          <img
                            src="assets/img/icon_tooltip.png"
                            alt="툴팁"
                            className="h-[24px] w-[24px]"
                            onMouseOver={() => {
                              setOpenExtensionTooltip((prev) => !prev)
                            }}
                          />
                          확장 프로그램이란?
                          <a
                            className="ml-1 flex cursor-pointer items-center gap-2 text-[14px]"
                            href="https://www.youtube.com/watch?v=VMJKnYM8rH4"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src="assets/img/icon_youtube.png"
                              alt="icon_youtube"
                              className="h-[26px] w-[26px]"
                            />
                            <span className="font-bold">
                              사용 가이드 영상 {`>`}
                            </span>{' '}
                          </a>
                          {isOpenExtensionTooltip && (
                            <ExtensionTooltip
                              setOpenExtensionTooltip={setOpenExtensionTooltip}
                            />
                          )}
                        </p>
                      </>
                    ) : (
                      //pc 3가지 버튼
                      <>
                        <p className="relative flex h-[42px] w-full items-center justify-evenly rounded-[10px] bg-[#EEF1F7]">
                          <button
                            className="flex items-center gap-1 text-[14px]"
                            type="button"
                            onClick={() => {
                              setOpenExtensionTooltip(true)
                            }}
                          >
                            <span className="text-[24px]"> ☝️</span>
                            확장 프로그램 사용 전 확인 필수 {`>`}
                          </button>
                          <button
                            className="flex items-center gap-1 text-[14px]"
                            type="button"
                            onClick={() => {
                              window.open(
                                'https://www.youtube.com/watch?v=VMJKnYM8rH4',
                              )
                            }}
                          >
                            <img
                              src="assets/img/icon_youtube.png"
                              alt="youtube"
                              className="h-[26px] w-[26px]"
                            />
                            1분 만에 이해 되는 사용법 영상 {`>`}
                          </button>
                          <button
                            className="flex items-center gap-1 text-[14px]"
                            type="button"
                            onClick={() => {
                              setOpenExtensionErrorGuideTooltip(true)
                            }}
                          >
                            {' '}
                            <span className="text-[24px]"> 🚨</span>자꾸
                            오류나요! 100% 해결법 {'>'}
                          </button>
                          {isOpenExtensionTooltip && (
                            <ExtensionTooltip
                              setOpenExtensionTooltip={setOpenExtensionTooltip}
                            />
                          )}
                          {isOpenExtensionErrorGuideTooltip && (
                            <ExtensionErrorGuideTooltip
                              setOpenExtensionErrorGuideTooltip={
                                setOpenExtensionErrorGuideTooltip
                              }
                            />
                          )}
                        </p>
                      </>
                    )}
                  </div>
                </div>
                {/* 새로운 창 */}

                {/* {isOpenLinkMethod && !isOpenExtensionMethod && (
                  <ProductListV1
                    watch={watch}
                    setValue={setValue}
                    control={control}
                    errors={errors}
                    error={error}
                    fields={fields}
                    userInfo={userInfo}
                    setErrorText={setErrorText}
                    setError={setError}
                    usage={usage}
                    isImageDivOpen={isImageDivOpen}
                    setImageDivOpen={setImageDivOpen}
                    productsRef={productsRef}
                    setTooltipStatus={setTooltipStatus}
                    tooltipStatus={tooltipStatus}
                  />
                )} */}
                <div className="flex w-full justify-center">
                  {fields.length < 3 && (
                    <button
                      type="button"
                      onClick={() => {
                        if (fields.length < 3) {
                          append({
                            link: '',
                            productName: '',
                            userScript: '',
                            files: [],
                            extensionCollectId: 0,
                            selectedFiles: [],
                            selectedDetails: [],
                            selectedThumbnails: [],
                            selectedVideos: [],
                            selectedVideoTotalDuration: 0,
                            withShort: 0,
                            subtitleFlag: 0,
                            bgmFlag: 0,
                            purchaseInfoFlag: 0,
                            productTemplateId: 0,
                            productTitle: '',
                            saveProductTemplateId: 0,
                            saveProductTitle: '',
                          })
                        }
                      }}
                    >
                      <img
                        src="assets/img/add.png"
                        height={32}
                        width={32}
                        alt="add"
                      />
                    </button>
                  )}
                </div>
              </div>
            </div>
          </ShadowBox>
          {watch('products.0.link') === '' && (
            <FeatureDescription
              description1="수집한 상품을 선택"
              description1_1=" 해주시면"
              description2="상품별 내용 편집 기능"
            />
          )}
          <ShadowBox>
            <div
              className={classNames(
                'flex w-[375px] flex-col items-center gap-[4px] md:w-[736px] md:gap-[16px]',
                {
                  'px-4': isMobile,
                  'opacity-50':
                    !isOpenLinkMethod && selectedLinkIds.length === 0,
                },
              )}
            >
              <div className="mt-[40px] flex w-[343px] flex-col items-center md:mt-0 md:w-full">
                <h3 className="text-[24px] font-bold text-[#2E343D]">
                  {createVideoType === CreateVideoType.PRODUCT_LONG
                    ? '상품별 내용 편집'
                    : '상품 내용 편집'}
                </h3>
                <p className="text-[14px] text-[#8F929B]">
                  상품명과 대본을 생성하고, 영상 소스를 선택하세요
                </p>
              </div>
              {!isOpenLinkMethod && selectedLinkIds.length > 0 ? (
                <ProductList
                  watch={watch}
                  setValue={setValue}
                  control={control}
                  errors={errors}
                  error={error}
                  fields={fields}
                  userInfo={userInfo}
                  setErrorText={setErrorText}
                  setError={setError}
                  usage={usage}
                  selectedLinks={selectedLinks}
                  isAiName={isAiName}
                  promptGroupList={aiPromptGroup ?? []}
                  setPromptStatus={setPromptStatus}
                  setToneTooltip={setToneTooltip}
                  promptStatus={promptStatus}
                  toneTooltip={toneTooltip}
                  translatePlanName={translatePlanName}
                  createVideoType={createVideoType}
                />
              ) : (
                !isOpenLinkMethod &&
                selectedLinkIds.length === 0 && (
                  <>
                    <ProductItemEmpty
                      watch={watch}
                      setValue={setValue}
                      control={control}
                      errors={errors}
                      error={error}
                      fields={fields}
                      userInfo={userInfo}
                      setErrorText={setErrorText}
                      setError={setError}
                      usage={usage}
                      selectedLinks={selectedLinks}
                      isAiName={isAiName}
                      isOpenLinkMethod={isOpenLinkMethod}
                      isOpenExtensionMethod={isOpenExtensionMethod}
                      setOpenLinkMethod={setOpenLinkMethod}
                      setOpenExtensionMethod={setOpenExtensionMethod}
                    />
                  </>
                )
              )}
            </div>
          </ShadowBox>

          {!isOpenLinkMethod &&
            selectedLinkIds.length > 0 &&
            createVideoType === CreateVideoType.PRODUCT_LONG && (
              <WithShortFormCreate
                watch={watch}
                trigger={trigger}
                setValue={setValue}
                control={control}
                userInfo={userInfo}
                selectedLinks={selectedLinks}
              />
            )}

          {createVideoType === CreateVideoType.PRODUCT_LONG && (
            <YoutubeTitle
              watch={watch}
              control={control}
              setValue={setValue}
              userInfo={userInfo}
              clipTitleIsPending={clipTitleIsPending}
              thumbnailIsPending={thumbnailIsPending}
              aiRecommendClipTitle={aiRecommendClipTitle}
              mainTitleInputRef={mainTitleInputRef}
              setError={setError}
              error={error}
              usage={usage}
            />
          )}

          <ShadowBox className="relative px-[16px] py-[40px] md:w-[816px]">
            {watch('products.0.link') === '' && (
              <div className="absolute left-0 z-50 h-full w-full bg-white px-[16px] py-[40px] opacity-50 md:w-[816px]"></div>
            )}
            <div
              className="flex w-[343px] flex-col gap-[40px] md:w-[736px] md:gap-0"
              ref={thumbNailDivRef}
            >
              <div className="mt-[16px] flex flex-col items-center md:mb-[40px]">
                <p className="text-[24px] font-bold text-[#2E343D]">
                  효과 선택
                </p>
                {createVideoType === CreateVideoType.PRODUCT_LONG && (
                  <p className="flex h-[18px] w-[159px] items-center justify-center rounded-[4px] bg-main text-center text-[10px] font-bold text-[#FFFFFF]">
                    <span>프로 / 프리미엄 플랜을 위한 기능</span>
                  </p>
                )}
                <p className="text-[14px] text-main">
                  원하는 분위기의 영상 생성을 위해 각 효과를 선택해주세요!
                </p>
              </div>

              {createVideoType === CreateVideoType.PRODUCT_SHORT && (
                <>
                  <CSSTransition
                    in={isOpen}
                    timeout={500}
                    classNames="content"
                    unmountOnExit
                  >
                    <FastcutShortformEffectSelector
                      watch={watch}
                      setValue={setValue}
                      control={control}
                      trigger={trigger}
                      errors={errors}
                      userInfo={userInfo}
                      translatePlanName={translatePlanName}
                      error={error}
                      setError={setError}
                      isOpenLinkMethod={isOpenLinkMethod}
                      selectedLinks={selectedLinks}
                      aiRecommendThumbnailTitle={aiRecommendThumbnailTitle}
                      placIdThumbnail={placIdThumbnail}
                      setPlacIdThumbnail={setPlacIdThumbnail}
                      isSaveThumbnail={isSaveThumbnail}
                      setIsSaveThumbnail={setIsSaveThumbnail}
                      thumbNailDivRef={thumbNailDivRef}
                      selectedPlacIdThumbnail={selectedPlacIdThumbnail}
                      setSelectedPlacIdThumbnail={setSelectedPlacIdThumbnail}
                      selectedItem={selectedItem}
                      setSelectedItem={setSelectedItem}
                      promptGroup={aiPromptGroup}
                      setPromptStatus={setPromptStatus}
                      promptStatus={promptStatus}
                      voiceList={voiceList}
                      userVoiceList={userVoiceList}
                      setVoicePlaying={setVoicePlaying}
                      voicePlaying={voicePlaying}
                      voiceTags={voiceTags}
                      setToneTooltip={setToneTooltip}
                      toneTooltip={toneTooltip}
                      userVoiceRefetch={userVoiceRefetch}
                      subTitleList={subTitleList ?? []}
                      subtitleColorList={subtitleColorList ?? []}
                      subtitleFontList={subtitleFontList ?? []}
                      subtitleSizeList={subtitleSizeList ?? []}
                      subtitleDivRef={subtitleDivRef}
                      bgmList={bgmList ?? []}
                      bgmRefs={bgmRefs}
                      setBgmPlaying={setBgmPlaying}
                      bgmPlaying={bgmPlaying}
                      handleBgmPlayButtonClick={handleBgmPlayButtonClick}
                    />
                  </CSSTransition>
                </>
              )}
              {createVideoType === CreateVideoType.PRODUCT_LONG && (
                <>
                  {' '}
                  <CSSTransition
                    in={isOpen}
                    timeout={500}
                    classNames="content"
                    unmountOnExit
                  >
                    <FastcutLongformEffectSelector
                      watch={watch}
                      setValue={setValue}
                      control={control}
                      userInfo={userInfo}
                      thumbnailList={thumbnailList ?? []}
                      thumbnailPlacIdList={thumbnailPlacIdList ?? []}
                      translatePlanName={translatePlanName}
                      error={error}
                      setError={setError}
                      isOpenLinkMethod={isOpenLinkMethod}
                      selectedLinks={selectedLinks}
                      aiRecommendThumbnailTitle={aiRecommendThumbnailTitle}
                      placIdThumbnail={placIdThumbnail}
                      setPlacIdThumbnail={setPlacIdThumbnail}
                      isSaveThumbnail={isSaveThumbnail}
                      setIsSaveThumbnail={setIsSaveThumbnail}
                      thumbNailDivRef={thumbNailDivRef}
                      selectedPlacIdThumbnail={selectedPlacIdThumbnail}
                      setSelectedPlacIdThumbnail={setSelectedPlacIdThumbnail}
                      selectedItem={selectedItem}
                      setSelectedItem={setSelectedItem}
                      promptGroup={aiPromptGroup}
                      setPromptStatus={setPromptStatus}
                      promptStatus={promptStatus}
                      voiceList={voiceList}
                      userVoiceList={userVoiceList}
                      setVoicePlaying={setVoicePlaying}
                      voicePlaying={voicePlaying}
                      voiceTags={voiceTags}
                      setToneTooltip={setToneTooltip}
                      toneTooltip={toneTooltip}
                      userVoiceRefetch={userVoiceRefetch}
                      subTitleList={subTitleList ?? []}
                      subtitleColorList={subtitleColorList ?? []}
                      subtitleFontList={subtitleFontList ?? []}
                      subtitleSizeList={subtitleSizeList ?? []}
                      subtitleDivRef={subtitleDivRef}
                      bgmList={bgmList ?? []}
                      bgmRefs={bgmRefs}
                      setBgmPlaying={setBgmPlaying}
                      bgmPlaying={bgmPlaying}
                      handleBgmPlayButtonClick={handleBgmPlayButtonClick}
                      copyTransitionList={copyTransitionList}
                      setSelectedTransitionIndex={setSelectedTransitionIndex}
                      selectedTransitionIndex={selectedTransitionIndex}
                      setTransitionModal={setTransitionModal}
                      handlePlayButtonClick={handlePlayButtonClick}
                      handleVideoEnded={handleVideoEnded}
                      handleMouseLeave={handleMouseLeave}
                      handleSelectedTransition={handleSelectedTransition}
                      videoRefs={videoRefs}
                      videoRef={videoRef}
                      transitionDivRef={transitionDivRef}
                      videoPlaying={videoPlaying}
                      introList={introList ?? []}
                      stickerList={stickerList}
                      stickerLocationList={stickerLocationList}
                      copyOutroList={copyOutroList}
                      setCopyOutroList={setCopyOutroList}
                    />
                  </CSSTransition>
                </>
              )}
              <div className="flex items-center justify-center">
                <button
                  className="flex w-full items-center justify-center gap-[8px] rounded-[40px] bg-[#EEF1F7] py-[12.5px]"
                  type="button"
                  onClick={toggleContent}
                >
                  <span>{isOpen ? '접기' : '펼치기'}</span>
                  <img
                    src="assets/img/icon_up_arrow.png"
                    alt="arrow"
                    className={`h-[8.25px] w-[12.8px] transition-transform duration-1000 ${
                      isOpen ? '' : 'rotate-180'
                    }`}
                  />
                </button>
              </div>
            </div>
          </ShadowBox>
          <div className="relative mt-4 text-center text-[16px]">
            패스트컷은 사용자가 제공하는 URL에 있는 텍스트/이미지/영상을 토대로
            영상을 만들고 있으며,
            <br /> 링크 내의 텍스트나 이미지, 영상 등이 영상에 사용될 수
            있습니다.
            <br /> 이에 대한 지적재산권 침해 여부는 사용자가 확인하여야 하며,
            이에 관하여 패스트컷은 책임이 없습니다.
            <br />
            <br />
            숏폼용 세로 영상도 함께 생성할 시 ‘패스트클릭’ 링크 서비스를
            사용하며{' '}
            <span
              className="cursor-pointer font-bold text-href underline"
              onClick={() => {
                setShortFormTooltip((prev) => !prev)
              }}
            >
              약관
            </span>{' '}
            11조 11항, 13조 6항에 동의하는 것입니다.
            {shortFormTooltip && (
              <ShortFormTooltip setShortFormTooltip={setShortFormTooltip} />
            )}
          </div>
          <div>
            <div className="flex flex-col items-center justify-center gap-[20px]">
              <button
                className={classNames(
                  'flex h-[60px] w-[343px] items-center justify-center gap-[4px] rounded-[30px] border-none bg-main font-bold text-[#FFFFFF] md:w-full',
                  {
                    'hover opacity-50':
                      (usage && usage.available === 0) ||
                      isPending ||
                      isSubmittingRef.current ||
                      watch('products.0.link') === '',
                  },
                )}
                disabled={
                  (usage && usage.available === 0) ||
                  isPending ||
                  isSubmittingRef.current ||
                  watch('products.0.link') === ''
                }
              >
                <span>영상 생성 요청</span>
              </button>
            </div>
          </div>
        </form>
        <div className={classNames('flex w-full flex-col')}>
          <FastclickDescription userInfo={userInfo} />
        </div>

        <div
          className={classNames('', {
            'flex w-full flex-col gap-8 rounded-[40px] bg-[#F6F8FB] px-8 py-10':
              !isMobile,
            'flex w-full flex-col gap-7 bg-[#F6F8FB] px-8 py-10': isMobile,
          })}
        >
          <p className="text-[24px] font-bold">
            🎯 궁금함이 해소 돼요! 자주 묻는 질문
          </p>
          <div>
            <p className="text-[20px] font-bold">
              확장 프로그램을 설치해야 상품 영상을 생성할 수 있나요?
            </p>
            <p className="text-[#5E6068]">
              네! 꼭 사용해주시기를 부탁드립니다.
              <br />
              확장 프로그램을 사용하셔야 영상에 사용될 이미지 등의 상품 정보를
              미리 보실 수 있기 때문에 영상의 퀄리티를 직접 관리하시는 면에서
              편의성이 현저히 높아집니다.
            </p>
            <p>
              <a
                className="font-bold text-error"
                href="https://www.youtube.com/watch?v=VMJKnYM8rH4"
                target="_blank"
                rel="noreferrer"
              >
                {`  확장 프로그램 사용안내 영상 >`}{' '}
              </a>
              <a
                className="font-bold text-[#4360EC]"
                href="https://chromewebstore.google.com/detail/%ED%8C%A8%EC%8A%A4%ED%8A%B8%EC%BB%B7ai/meeeiblldcmbdhhaibnbpdiiknkoaakl?utm_source=item-share-cb"
                target="_blank"
                rel="noreferrer"
              >{`확장 프로그램 설치하기>`}</a>
            </p>
          </div>
          <div>
            <p className="text-[20px] font-bold">영상 생성 언제 되나요?</p>
            <p className="text-[#5E6068]">
              영상 생성은{' '}
              <span className="font-bold text-main">요청 후 1일 내</span>에
              완료됩니다.{' '}
            </p>
          </div>
          <div>
            <p className="text-[20px] font-bold">
              생성된 영상 다운로드 어디서 하나요?
            </p>
            <p className="text-[#5E6068]">
              다운로드는{' '}
              <span
                className="cursor-pointer font-bold text-href underline"
                onClick={() => {
                  navigate('/my-videos')
                }}
              >
                사용 현황
              </span>{' '}
              페이지에서 생성 완료된 시점으로부터 30일간 가능합니다.
            </p>
          </div>
          <div>
            <p className="text-[20px] font-bold">
              영상 생성 개수 기준이 뭔가요?
            </p>
            <p className="text-[#5E6068]">
              플랜별 영상 생성 개수는 사용자가{` `}
              <span className="font-bold text-main">
                ‘생성 요청한 영상’ 개수
              </span>
              를 기준으로 카운팅 합니다.
            </p>
          </div>
          <div>
            <p className="text-[20px] font-bold">
              하루 3개 자동업로드 되면, 하루 3개만 생성할 수 있나요?
            </p>
            <p className="text-[#5E6068]">
              아니요! 하루 영상 생성 요청{' '}
              <span className="font-bold text-main">개수 제한은 없습니다.</span>{' '}
              프로,프리미엄 플랜은 자동 업로드 설정을 완료 했을시, 생성 요청 건
              모두{' '}
              <span className="font-bold text-main">
                요청 다음날부터 매일 하루 3개씩 순차적으로
              </span>{' '}
              오전 10시, 오후 2시, 오후 6시에{' '}
              <span className="font-bold text-main">
                예약 공개 상태로 자동 업로드
              </span>
              됩니다. 공개 일정 변경은 유튜브 스튜디오에서 자유롭게 가능합니다.
            </p>
          </div>
        </div>

        <GuideToUse />
        {!isRequest && <Spinner />}
        {essentialCheck && (
          <Modal isModal={essentialCheck}>
            <div className="h-auto min-h-[184px] w-[335px] rounded-t-[20px] border-t bg-white p-[20px]">
              <div className="flex h-full flex-col items-center justify-center gap-[24px]">
                <p className="text-[18px] font-bold">
                  {errorTitle === ''
                    ? '🙌 필수 정보를 입력해주세요!'
                    : errorTitle}
                </p>
                <p className="w-full text-[14px]">{errorText}</p>
                {/* <p className="text-red-500">{errorMessage}</p> */}
              </div>
            </div>
            <div className="flex h-[60px] w-[335px] items-center justify-center rounded-b-[20px] border-b border-main bg-main">
              <button
                className="w-[400px] font-bold text-white"
                onClick={() => {
                  setRequest(true)
                  setEssentialCheck(false)
                }}
              >
                확인
              </button>
            </div>
          </Modal>
        )}
        {saveSuccessModal && (
          <Modal isModal={saveSuccessModal}>
            <div className="h-[184px] w-[335px] rounded-t-[40px] border-t bg-white p-[20px] md:w-[400px]">
              <div className="flex h-full flex-col items-center justify-center gap-[24px]">
                <p className="text-[18px] font-bold">요청 완료</p>
                <div>
                  <p className="text-[14px]">
                    {usage?.usedCount && (
                      <span className="font-bold text-main">
                        총 {Number(usage?.usedCount) + 1}개
                      </span>
                    )}{' '}
                    /{' '}
                    <span className="text-[#8F929B]">
                      {usage?.totalLimit}개
                    </span>
                  </p>
                  <p className="text-[14px] font-bold text-main">
                    영상이 요청되었습니다.
                  </p>
                  <p className="text-[14px">
                    생성 현황은 <span className="font-bold">‘사용 현황'</span>{' '}
                    페이지에서 확인하세요.
                  </p>
                </div>
              </div>
            </div>
            <div className="flex h-[60px] w-[335px] items-center justify-center rounded-b-[40px] md:w-[400px]">
              <button
                className="h-full w-[50%] rounded-bl-[40px] border border-[#EEF1F7] bg-[#EEF1F7] font-bold text-[#5E6068]"
                onClick={() => {
                  setSaveSuccessModal(false)
                  refetch()
                  usageRefetch()
                  navigate('/my-videos')
                }}
              >
                사용 현황 페이지 가기
              </button>
              <button
                className="h-full w-[50%] rounded-br-[40px] border border-main bg-main font-bold text-white"
                onClick={() => {
                  const isTrialUser = userInfo?.userType === UserType.체험
                  const isProUser = userInfo?.userType === UserType.프로
                  const isPremiumUser = userInfo?.userType === UserType.프리미엄
                  const isUsageLimitReached =
                    Number(usage?.usedCount) + 1 === Number(usage?.totalLimit)

                  try {
                    if (
                      (isProUser || isPremiumUser || isTrialUser) &&
                      isUsageLimitReached
                    ) {
                      setSaveSuccessModal(false)
                      refetch()
                      usageRefetch()
                      handleInitData()
                      navigate('/my-videos')
                    } else {
                      setSaveSuccessModal(false)
                      //window.location.reload()
                      refetch()
                      usageRefetch()
                      handleInitData()
                    }
                  } catch (error) {
                    handleInitData()
                    refetch()
                    usageRefetch()
                  }
                }}
              >
                확인
              </button>
            </div>
          </Modal>
        )}

        {isPlanPriceModal && (
          <PlanPriceModal
            isPlanPriceModal={isPlanPriceModal}
            setPlanPriceModal={setPlanPriceModal}
            userInfo={userInfo}
          />
        )}
        {mobileStatus && (
          <Modal isModal={mobileStatus}>
            <div className="h-[150px] w-[300px] rounded-t-[20px] border-t bg-white p-[20px]">
              <div className="flex h-full flex-col items-center justify-center gap-[24px]">
                <p className="text-[18px] font-bold">
                  스마트폰으로 접속하셨습니다.
                </p>
                <div className="flex flex-col leading-[22px]">
                  <p className="font-bold text-main">PC사용을 권장합니다.</p>
                </div>
              </div>
            </div>
            <div className="flex h-[40px] w-[300px] items-center justify-center rounded-b-[20px] border-b border-main bg-main">
              <button
                className="w-[330px] text-white"
                onClick={() => {
                  setMobileStatus((prev) => !prev)
                }}
              >
                확인
              </button>
            </div>
          </Modal>
        )}
        {isYoutube && (
          <Modal isModal={isYoutube}>
            <div className="h-[184px] w-[400px] rounded-t-[20px] border-t bg-white p-[20px]">
              <div className="flex h-full flex-col items-center justify-center gap-[24px]">
                <p className="text-[18px] font-bold">
                  🚨 필수! 자동 업로드 설정을 해주세요!
                </p>
                <div className="flex flex-col leading-[22px]">
                  <p className="">
                    패스트컷 프로/프리미엄 플랜의 완벽한 사용을 위해
                    <br /> 내 유튜브 채널 현황을 파악하고 <br />
                    자동업로드가 될 수 있도록 설정 해주셔야 합니다 🙏
                  </p>
                </div>
              </div>
            </div>
            <div className="flex h-[60px] w-[400px] items-center justify-center rounded-b-[20px] border-b border-main bg-main">
              <button
                className="w-[330px] text-white"
                onClick={() => {
                  setIsYoutube((prev) => !prev)
                  navigate('/youtube-auth')
                }}
              >
                자동업로드 설정하러 가기
              </button>
            </div>
          </Modal>
        )}

        <ScriptSelector
          watch={watch}
          setValue={setValue}
          control={control}
          translatePlanName={translatePlanName}
          promptGroupList={aiPromptGroup}
          userInfo={userInfo}
          setPromptStatus={setPromptStatus}
          setToneTooltip={setToneTooltip}
          promptStatus={promptStatus}
          toneTooltip={toneTooltip}
        />

        {isOpenExtensionMethod && (
          <ExtensionListModal
            watch={watch}
            userInfo={userInfo}
            setValue={setValue}
            control={control}
            isOpenExtensionMethod={isOpenExtensionMethod}
            setOpenExtensionMethod={setOpenExtensionMethod}
            setIsOpenExtensionListFailModal={setIsOpenExtensionListFailModal}
            selectedLinkIds={selectedLinkIds}
            setSelectedLinkIds={setSelectedLinkIds}
            linkPageSize={linkPageSize}
            setLinkPageSize={setLinkPageSize}
            linkCurrentPage={linkCurrentPage}
            setLinkCurrentPage={setLinkCurrentPage}
            LINK_PAGE_CNT={LINK_PAGE_CNT}
            setSelectedLinks={setSelectedLinks}
            setAiName={setAiName}
            isAiName={isAiName}
            setAiRecommendClipTitle={setAiRecommendClipTitle}
            setAiRecommendThumbnailTitle={setAiRecommendThumbnailTitle}
            mutateAsync={mutateAsync}
            isPending={isPending}
            thumbnailMutateAsync={thumbnailMutateAsync}
            thumbnailIsPending={thumbnailIsPending}
            createVideoType={createVideoType}
          />
        )}
        {isGuideModal && (
          <GuideModal
            isGuideModal={isGuideModal}
            setGuideModal={setGuideModal}
            userInfo={userInfo}
          />
        )}
        {isFailWithShortModal && (
          <FailWithShortModal
            isFailWithShortModal={isFailWithShortModal}
            setFailWithShortModal={setFailWithShortModal}
            handleScroll={handleScroll}
          />
        )}

        {isOpenExtensionListFailModal && (
          <ExtensionListFailModal
            isOpenExtensionListFailModal={isOpenExtensionListFailModal}
            setIsOpenExtensionListFailModal={setIsOpenExtensionListFailModal}
          />
        )}

        <TransitionModal
          isTransitionModal={isTransitionModal}
          setTransitionModal={setTransitionModal}
          handleLoadedMetadata={handleLoadedMetadata}
          handlePlayButtonClick={handlePlayButtonClick}
          handleVideoEnded={handleVideoEnded}
          videoRefs={videoRefs}
          videoPlaying={videoPlaying}
          userInfo={userInfo}
          Controller={Controller}
          watch={watch}
          translatePlanName={translatePlanName}
          control={control}
          setValue={setValue}
          selectedTransitionIndex={selectedTransitionIndex}
          setSelectedTransitionIndex={setSelectedTransitionIndex}
          copyTransitionList={copyTransitionList}
          setCopyTransitionList={setCopyTransitionList}
        />
      </div>
    </>
  )
}
